import express from "../../assets/images/expressjs_logo_icon_169185.png";

const stack = [
  {
    id: "01",
    image: "https://img.icons8.com/color/48/000000/javascript.png",
    title: "JavaScript",
    category: "Frontend",
  },
  {
    id: "02",
    image: "https://img.icons8.com/ultraviolet/48/000000/react.png",
    title: "React",
    category: "Frontend",
  },

  {
    id: "04",
    image: "https://img.icons8.com/color/48/000000/tailwind_css.png",
    title: "Tailwind CSS",
    category: "Frontend",
  },

  {
    id: "06",
    image: "https://img.icons8.com/officel/48/000000/php-logo.png",
    title: "PHP",
    category: "Backend",
  },
  {
    id: "07",
    image: "https://img.icons8.com/color/48/000000/nodejs.png",
    title: "Node.js",
    category: "Backend",
  },
  {
    id: "08",
    image: express,
    title: "Express",
    category: "Backend",
  },
  {
    id: "09",
    image: "https://img.icons8.com/color/48/000000/mysql-logo.png",
    title: "MySQL",
    category: "Backend",
  },

  {
    id: "10",
    image: "https://img.icons8.com/color/48/000000/figma.png",
    title: "Figma",
    category: "UI/UX",
  },
  {
    id: "11",
    image: "https://img.icons8.com/color/48/000000/wordpress.png",
    title: "WordPress",
    category: "Backend",
  },
];

export default stack;
